import { render, staticRenderFns } from "./common-problem-english.vue?vue&type=template&id=3b5c7080&scoped=true"
import script from "./common-problem-english.vue?vue&type=script&lang=js"
export * from "./common-problem-english.vue?vue&type=script&lang=js"
import style0 from "./common-problem-english.vue?vue&type=style&index=0&id=3b5c7080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c7080",
  null
  
)

export default component.exports